import create, { SetState } from 'zustand';

export interface IInkindStore {
  inkindRouteId?: string;

  setInkindRouteId(id: string): void;
}

export const [useInkindStore, inkindStoreApi /* TODO: remove when migration is finished */] = create<IInkindStore>(
  (set: SetState<IInkindStore>) => ({
    inkindRouteId: null,

    setInkindRouteId: (id: string) =>
      set(() => {
        return {
          inkindRouteId: id,
        };
      }),
  })
);
